import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.featureGroups.set.mutation.gql"
import type {
  AddOnFeatureGroupsSetMutation,
  AddOnFeatureGroupsSetMutationVariables,
} from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.featureGroups.set.mutation"

type Options = MutationHookOptions<
  AddOnFeatureGroupsSetMutation,
  AddOnFeatureGroupsSetMutationVariables
>

export function useAddOnFeatureGroupsSetMutation(options?: Options) {
  return useMutation<
    AddOnFeatureGroupsSetMutation,
    AddOnFeatureGroupsSetMutationVariables
  >(mutation, options)
}
